"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileOverlaySection;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _core = require("@linaria/core");
var _animation = require("../../../animation");
var _mobileNavLink = _interopRequireDefault(require("../navigation-items/mobile-nav-link.js"));
var _base = require("@site/pattern-library-utils/base.functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// ============================================================================
// STYLED COMPONENTS
// ============================================================================

const MobileMenu = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MobileMenu",
  class: "pl-m9cqkj",
  vars: {
    "m9cqkj-0": [({
      expanded
    }) => expanded ? 'flex' : 'none'],
    "m9cqkj-2": [({
      isSticky
    }) => isSticky ? 'fixed' : 'absolute'],
    "m9cqkj-3": [({
      isSticky
    }) => isSticky ? '3.5rem' : '100%'],
    "m9cqkj-4": [({
      isSticky
    }) => isSticky ? 'calc(90vh - 3.5rem)' : '90vh']
  }
});
const MobileMenuDropdown = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MobileMenuDropdown",
  class: "pl-m16fr0dv",
  vars: {
    "m16fr0dv-0": [({
      isExpanded
    }) => isExpanded ? _intents.default.ux.box.backgroundColorSecondary : 'transparent'],
    "m16fr0dv-3": [({
      isExpanded
    }) => isExpanded ? 'block' : 'none']
  }
});
const MobileMenuItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "MobileMenuItem",
  class: "pl-m1utzdv6"
});
const MobileDropdownItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "MobileDropdownItem",
  class: "pl-m18lnnp4"
});
const MobileDropdownContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileDropdownContainer",
  class: "pl-mr2wqtq"
});
const MobileMenuGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileMenuGroup",
  class: "pl-m1yzzd0x",
  vars: {
    "m1yzzd0x-0": [({
      isExpanded
    }) => isExpanded ? _intents.default.ux.navigateSecondaryChosen.backgroundColor : ''],
    "m1yzzd0x-1": [({
      isExpanded
    }) => isExpanded ? _intents.default.ux.actionPrimaryHovered.borderRadius : '0'],
    "m1yzzd0x-4": [({
      isExpanded
    }) => isExpanded ? 'none' : 'block']
  }
});
const MenuOverlay = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MenuOverlay",
  class: "pl-mkeun9r",
  vars: {
    "mkeun9r-0": [({
      show
    }) => show ? 'static' : 'none']
  }
});

// ============================================================================
// ANIMATION STYLES
// ============================================================================

const overlayAnimation = "pl-o1eui6zp";
const dropdownAnimation = "pl-d1778upk";
const chevronOpen = "pl-c1cey5m5";
const chevronClose = "pl-c1ihexny";
const menuItemFadeIn = "pl-m2kcwsd";
const menuItemFadeOut = "pl-moauci2";

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

const CHILDREN_ITEM_NAME = 'children';
const hasChildrenStructure = items => {
  return items?.length === 1 && items[0]._name === CHILDREN_ITEM_NAME;
};
const extractItemList = items => {
  return hasChildrenStructure(items) ? items[0].items : items;
};
const hasDropdownContent = (items, itemList) => {
  return items?.length > 0 && itemList;
};

// ============================================================================
// MAIN COMPONENT
// ============================================================================

/**
 * Mobile Overlay Section Component
 *
 * Renders a full-screen mobile navigation overlay with expandable groups.
 * Supports nested menu items and smooth animations.
 * @param {Object} props - Component props
 * @returns {React.ReactElement} Mobile Overlay Section Component
 */
function MobileOverlaySection({
  expanded,
  liveList,
  expandedGroup,
  toggleGroup,
  isSticky = false,
  clickOutsideHandler
}) {
  const mobileMenuRef = (0, _react.useRef)(null);

  // Memoized handlers to avoid recreation in render loop
  const handlers = (0, _react.useMemo)(() => ({
    createGroupInteraction: itemIndex => () => toggleGroup(itemIndex),
    createGroupKeyPress: itemIndex => ({
      key
    }) => {
      if (key === 'Enter') {
        toggleGroup(itemIndex);
      }
    }
  }), [toggleGroup]);
  (0, _base.useClickOutside)(mobileMenuRef.current, () => {
    clickOutsideHandler();
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MobileMenu, {
    className: `mobile-overlay-section ${dropdownAnimation}`,
    "data-cy": "mobile-menu",
    expanded: expanded,
    isSticky: isSticky,
    ref: expanded ? mobileMenuRef : null
  }, liveList?.filter(Boolean).map((menuItem, itemIndex) => {
    const {
      items
    } = menuItem || {};
    const processedItemList = extractItemList(items);
    if (hasDropdownContent(items, processedItemList)) {
      const {
        title
      } = menuItem;

      // Use memoized handlers instead of creating new ones
      const handleGroupInteraction = handlers.createGroupInteraction(itemIndex);
      const handleGroupKeyPress = handlers.createGroupKeyPress(itemIndex);
      return /*#__PURE__*/_react.default.createElement(MobileMenuDropdown, {
        key: itemIndex,
        "data-cy": "mobile-menu-dropdown",
        tabIndex: 0,
        onClick: handleGroupInteraction,
        onKeyPress: handleGroupKeyPress,
        isExpanded: expandedGroup === itemIndex
      }, /*#__PURE__*/_react.default.createElement(MobileMenuGroup, {
        "data-cy": "mobile-menu-group",
        isExpanded: expandedGroup === itemIndex
      }, title, /*#__PURE__*/_react.default.createElement("div", {
        "data-cy": "down-chevron",
        className: "group-chevron"
      }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "chevron-down",
        className: expandedGroup === itemIndex ? chevronOpen : chevronClose
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: expandedGroup === itemIndex ? dropdownAnimation : menuItemFadeOut
      }, expandedGroup === itemIndex && /*#__PURE__*/_react.default.createElement(MobileDropdownContainer, null, processedItemList?.map((subItem, subItemIndex) => /*#__PURE__*/_react.default.createElement(MobileDropdownItem, {
        key: subItemIndex,
        "data-cy": "mobile-dropdown-item",
        className: menuItemFadeIn
      }, /*#__PURE__*/_react.default.createElement(_mobileNavLink.default, subItem))))));
    }
    const {
      _name: itemName,
      href,
      title,
      active,
      anchor
    } = menuItem;
    return /*#__PURE__*/_react.default.createElement(MobileMenuItem, {
      key: itemIndex,
      "data-cy": "mobile-menu-item",
      className: menuItemFadeIn
    }, /*#__PURE__*/_react.default.createElement(_mobileNavLink.default, {
      _name: itemName,
      href,
      title,
      active,
      anchor
    }));
  })), /*#__PURE__*/_react.default.createElement(MenuOverlay, {
    "data-cy": "mobile-menu-overlay",
    className: overlayAnimation,
    show: expanded
  }));
}
MobileOverlaySection.propTypes = {
  expanded: _propTypes.default.bool.isRequired,
  liveList: _propTypes.default.array.isRequired,
  expandedGroup: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]).isRequired,
  toggleGroup: _propTypes.default.func.isRequired,
  isSticky: _propTypes.default.bool,
  clickOutsideHandler: _propTypes.default.func
};